import { BootstrapVue, IconsPlugin } from "bootstrap-vue"
import { get, sync } from "vuex-pathify"
import { AxiosError } from "axios"
import { ApiError } from "rp-components"
import Vue from 'vue'
import {ConfirmationDialogInfo, MultiConfirmationDialogInfo} from "@/store/RootStore"

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

export default Vue.extend({
    name: 'App',

    watch: {
        'error': {
            handler: 'onErrorChange'
        },
        'alert': {
            handler: 'onAlertChanged'
        },
        'confirmation': {
            handler: 'onConfirmationChange'
        },
        'multiConfirmation': {
            handler: 'onMultiConfirmationChange'
        }
    },

    data() {
        return {
            showConfirm: false,
            showMultiConfirm: false
        }
    },

    computed: {
        confirmation: get<ConfirmationDialogInfo>("confirmation"),
        multiConfirmation: get<MultiConfirmationDialogInfo>("multiConfirmation"),
        confirmationFeedback: sync<string>("confirmationFeedback"),
        error: get<Error>("error"),
        alert: sync<string | undefined>("alert"),

        showConfirmation: {
            get() {
                return this.showConfirm
            },
            set(value: boolean) {
                this.showConfirm = value
            }
        },

        okConfirmTitle(): string {
            return this.confirmation?.okTitle ?? "OK"
        },

        okConfirmVariant(): string {
            return this.confirmation?.okVariant ?? "outline-primary"
        },

        cancelConfirmTitle(): string {
            return this.confirmation?.cancelTitle ?? "Cancel"
        },
        cancelConfirmVariant(): string {
            return this.confirmation?.cancelVariant ?? "secondary"
        },

        showTextArea(): boolean {
            return this.confirmation?.reason ?? false
        },

        confirmationFeedbackText: {
            get(): string {
                return this.confirmationFeedback ?? ""
            },
            set(newValue: string) {
                this.confirmationFeedback = newValue
            }
        },

        firstAction() {
            return () => {
                this.multiConfirmation?.firstAction()
                this.showMultiConfirm = false
            }
        },

        firstActionTitle() {
            return this.multiConfirmation?.firstActionTitle ?? "Yes"
        },

        firstActionVariant() {
            return this.multiConfirmation?.firstActionVariant ?? "primary"
        },

        secondAction() {
            return () => {
                this.multiConfirmation?.secondAction()
                this.showMultiConfirm = false
            }
        },

        secondActionTitle() {
            return this.multiConfirmation?.secondActionTitle ?? "No"
        },

        secondActionVariant() {
            return this.multiConfirmation?.secondActionVariant ?? "outline-primary"
        },

        cancelMultiConfirmTitle() {
            return this.multiConfirmation?.cancelTitle ?? "Cancel"
        },

        cancelMultiConfirmVariant() {
            return this.multiConfirmation?.cancelVariant ?? "secondary"
        }
    },
    methods: {
        onConfirmationChange() {
            this.showConfirm = true
        },

        onMultiConfirmationChange() {
            this.showMultiConfirm = true
        },

        onErrorChange(err: Error) {
            let msg = err.message
            const axiosErr = err as AxiosError | undefined
            const apiError = axiosErr?.response?.data as ApiError | undefined
            if (apiError?.errorMessage) {
                msg = apiError.errorMessage
            }
            this.$bvToast.toast(msg, {
                title: "Error",
                variant: "danger"
            })
        },

        onAlertChanged() {
            if (this.alert !== undefined) {
                this.$bvToast.toast(this.alert, {
                    title: "Success",
                    variant: "success"
                })
                this.alert = undefined
            }
        },

        confirmationCancelAction() {
            if (this.confirmation?.cancel) {
                this.confirmation.cancel()
            }
        },

        multiConfirmationCancelAction() {
            this.showMultiConfirm = false
            if (this.multiConfirmation?.cancel) {
                this.multiConfirmation.cancel()
            }
        }
    },
});
